const { withPrefix } = require('gatsby');
const WebFont = require('webfontloader');

exports.onInitialClientRender = () => {
  WebFont.load({
    custom: {
      families: ['EconSans, GTZirkon'],
      urls: [withPrefix('/fonts/fonts.css')],
    },
  });
};
